import _ from 'lodash'

const dorothyStoreInfo = Object.freeze({
    'US-DC-15': {
        alternativeStores: [ 'US-DC-13' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee', 'asset-user' ],
        warehouseId: 'WAC4',
        region: 'iad',
    },
    'US-DC-13': {
        alternativeStores: [ 'US-DC-15' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WBH0',
        region: 'iad',
    },
    'US-CA-162': {
        alternativeStores: [ 'US-CA-189' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'OAK0',
        region: 'pdx',
    },
    'US-CA-189': {
        alternativeStores: [ 'US-CA-162' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WBU7',
        region: 'iad',
    },
    // Katherine (ECO Dashcart) stores
    'US-MA-33': {
        alternativeStores: [ 'US-MA-47' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WWA5',
        region: 'iad',
    },
    'US-MA-47': {
        alternativeStores: [ 'US-MA-33' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'KTH2',
        region: 'iad',
    },
    'US-TX-25': {
        alternativeStores: [ 'US-TX-63' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WIA0',
        region: 'iad',
    },
    'US-TX-63': {
        alternativeStores: [ 'US-TX-25' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'KTH3',
        region: 'iad',
    },
    'US-WA-16': {
        alternativeStores: [ 'US-WA-999' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WHA3',
        region: 'iad',
    },
    'US-WA-999': {
        alternativeStores: [ 'US-WA-16' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'KTH1',
        region: 'pdx',
    },
    'US-CO-9': {
        alternativeStores: [ 'US-CO-36' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WAV3',
        region: 'iad',
    },
    'US-CO-36': {
        alternativeStores: [ 'US-CO-9' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'SGN1',
        region: 'iad',
    },
    'US-NE-1': {
        alternativeStores: [ 'US-NE-3' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WAM9',
        region: 'iad',
    },
    'US-NE-3': {
        alternativeStores: [ 'US-NE-1' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'RGY1',
        region: 'iad',
    },
    'US-CA-35': {
        alternativeStores: [ 'US-CA-259' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WAL2',
        region: 'iad',
    },
    'US-CA-259': {
        alternativeStores: [ 'US-CA-35' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'KTH6',
        region: 'pdx',
    },
    'US-TX-55': {
        alternativeStores: [ 'US-TX-97' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WBF9',
        region: 'iad',
    },
    'US-TX-97': {
        alternativeStores: [ 'US-TX-55' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'WFM1',
        region: 'iad',
    },
    'US-VA-47': {
        alternativeStores: [ 'US-VA-45' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'ROW4',
        region: 'iad',
    },
    'US-VA-45': {
        alternativeStores: [ 'US-VA-47' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WRT1',
        region: 'iad',
    },
    'US-TX-110': {
        alternativeStores: [ 'US-TX-102' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'TOT2',
        region: 'iad',
    },
    'US-TX-102': {
        alternativeStores: [ 'US-TX-110' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'WMC2',
        region: 'iad',
    },
    'PD-AA-7': {
        alternativeStores: [ 'IA-AA-8' ],
        acceptedUserTypes: [ 'wfm-employee', 'amazon-employee' ],
        warehouseId: 'OEN5',
        region: 'pdx',
    },
    'IA-AA-8': {
        alternativeStores: [ 'PD-AA-7' ],
        acceptedUserTypes: [ 'wfm-employee' ],
        warehouseId: 'MAX6',
        region: 'iad',
    },
})

export class DorothyUtils {
    /**
     * Retrieve Dorothy project information for a store.
     *
     * @param storeId - store ID
     * @returns - Dorothy info object
     * @returns - undefined if store is not Dorothy-enabled
     */
    public static getDorothyStoreInfo (storeId) {
        return dorothyStoreInfo.hasOwnProperty(storeId) ? _.cloneDeep(dorothyStoreInfo[storeId]) : undefined
    }

    /**
     * Retrieve all available Dorothy stores starting from a primary store.
     *
     * @param primaryStoreId - the primary store to start from.
     *
     * @returns - Array of Dorothy store objects (see `dorothyStoreInfo`).
     */
    public static getAvailableStores (primaryStoreId) {
        if (!dorothyStoreInfo.hasOwnProperty(primaryStoreId)) {
            return []
        }

        return [primaryStoreId].concat(dorothyStoreInfo[primaryStoreId].alternativeStores).map((storeId) => {
            const storeInfo = _.cloneDeep(dorothyStoreInfo[storeId])
            storeInfo.storeId = storeId
            return storeInfo
        })
    }
}
